// extracted by mini-css-extract-plugin
export default {"SubMenuFrame":"mobileSubMenu_SubMenuFrame__Cjt2d","activeOption":"mobileSubMenu_activeOption__0fl7d"};